import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['link']

  connect (): void {
    const turboFrame = document.querySelector('#risks_page_view_frame')

    if (turboFrame != null) {
      turboFrame.classList.remove('hidden')
      const observer = new MutationObserver(() => {
        const panel = turboFrame.querySelector('.page-view.hidden')
        if (panel != null) {
          panel.classList.remove('hidden')
        }
      })
      observer.observe(turboFrame, { childList: true, subtree: true })
    }
  }

  select (event: Event): void {
    const allCells = document.querySelectorAll('.absolute.inset-0.rounded-md')
    allCells.forEach(cell => cell.classList.remove('border-3', 'border-black'))

    const clickedLink = event.currentTarget as HTMLElement
    clickedLink.classList.add('border-3', 'border-black')
  }

  close (): void {
    const turboFrame = document.querySelector('#risks_page_view_frame')
    if (turboFrame != null) {
      turboFrame.innerHTML = ''
    }

    const allCells = document.querySelectorAll('.absolute.inset-0.rounded-md')
    allCells.forEach(cell => cell.classList.remove('border-3', 'border-black'))
  }
}
